import React from "react";
import { getGrievanceListAPI, replyGrievanceAPI } from "../../api";
import useLogout from "../../utils/Utils";
import { useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import MyDataTable from "../../myComponents/DataTable/MyDataTable";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
} from "../../components/Component";
import { useEffect } from "react";
import { decrypt, encrypt } from "../../utils/Encrypt";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import ViewImgAndPdf from "../../myComponents/modals/ViewImgAndPdf";
import { UserAvatarCell } from "../../myComponents/form/UserAvatarCell";
import { Badge, Form, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Required from "../../myComponents/validate/Required";

const Grievance = () => {
  const logout = useLogout();
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const IMAGE_BASE_URL = localStorage.getItem("IMAGE_BASE_URL");
  // Modal Image Preview
  const [imageOpen, setImageOpen] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      file: null,
      file_url: null,
    },
  });
  const [column, setColumn] = useState([
    {
      name: "User",
      selector: (row) => row?.name,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "6px 0",
          }}
        >
          <UserAvatarCell row={row} image={row?.profile} name={row?.name} />

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontWeight: 600,
                fontSize: "15px",
                color: "#111827",
                lineHeight: "1.2",
              }}
            >
              {row?.name || "N/A"}
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {row?.email || "No email"}
            </span>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <span>{row?.mobile_no || 0}</span>
            </div>
          </div>
        </div>
      ),
      sortable: true,
      width: "250px",
    },

    {
      name: "Address",
      selector: (row) => row?.address,
      sortable: true,
      wrap: true,
    },
    {
      name: "Complain Id",
      selector: (row) => row?.complaint_id,
      sortable: true,
      wrap: true,
    },
    {
      name: "Complain Type",
      selector: (row) => row?.complain_type,
      sortable: true,
      wrap: true,
    },
    {
      name: "Complain Subject",
      selector: (row) => row?.complain_subject,
      sortable: true,
      wrap: true,
    },
    {
      name: "Complain",
      selector: (row) => row?.complain,
      sortable: true,
      wrap: true,
    },
    {
      name: "File",
      selector: (row) => (
        <div onClick={() => handleImageOpenPreview(`${IMAGE_BASE_URL}` + row?.file)}>
          <img style={{ width: "50px" }} src={`${IMAGE_BASE_URL}` + row.file} />
        </div>
      ),
    },
     {
      name: "Response",
      selector: (row) => row?.reply||"-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div>
          <Badge color={`${row?.status == "pending" ? "warning" : row?.status == "resolved" ? "success" : "danger"}`}>
            {row?.status == "pending" ? "Pending" : row?.status == "resolved" ? "Resolved" : "Open"}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <Button outline color={`danger`} size={`xs`} onClick={() => handleReply(row)}>
          {" "}
          <Icon name="reply"></Icon>
        </Button>
      ),
    },
  ]);
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  const getFileTypeFromUrl = (url) => {
    if (typeof url !== "string") return "";
    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      return "youtube";
    }
    const fileExtension = url.split(".").pop().split(/#|\?/)[0];
    return fileExtension.toLowerCase();
  };

  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("fileType", getFileTypeFromUrl(row));
    setValue("image_preview", row);
    trigger("image_preview");
  };
  useEffect(() => {
    grievanceList();
  }, []);
  const grievanceList = () => {
    setIsLoading(true);
    getGrievanceListAPI()
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);
        if (status === "success") {
          setIsLoading(false);
          const decryptedResponse = decrypt(res.data.data);
          toast.success(res.data.message);
          setData(decryptedResponse);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          setIsLoading(false);
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {});
  };
  const toggleModal = () => {
    reset();
    setShowModal(false);
  };
  const handleReply = (row) => { 
    setValue("selectedRow", row);
    setValue("complain", row?.complain);
    setShowModal(true);
  };
  const onFormSubmit = (data) => {
    const body = {
      complaint_id: watch("selectedRow")?.complaint_id,
      response: watch("response"),
    };
     const encryptedData = encrypt(body);
        const encryptData = {
          zero: encryptedData,
        };
    setLoading(true); 
    replyGrievanceAPI(encryptData)
      .then((res) => {
        const status = decrypt(res.data.status);
        if (status === "success") {
          setLoading(false);
          reset();
          grievanceList();
          toggleModal();
        } else if (status === "failed") {
          setLoading(false);
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  console.log(data)
  return (
    <>
      <Head title={"Grievance"} />
      <Content>
        <div className="container-fluid ">
          <BlockHead size={`sm`}>
            <BlockBetween>
              <BlockHeadContent>
                <BlockTitle page tag="h3">
                  {"Grievances"}
                </BlockTitle>
              </BlockHeadContent>
            </BlockBetween>
          </BlockHead>
          <Block>
            <Row className={`g-gs`}>
              <MyDataTable data={data} columns={column} title={"Grievance List"} isLoading={isLoading} />
            </Row>
          </Block>
        </div>
      </Content>

      <ViewImgAndPdf
        fileType={watch("fileType")}
        titleName={""}
        isOpen={imageOpen}
        toggleModal={handleImageClose}
        images={[watch("image_preview")]}
        currentImageIndex={0}
      />
      <Modal isOpen={showModal} toggle={toggleModal} size="xl" modalClassName="zoom">
        <ModalHeader toggle={toggleModal}></ModalHeader>
        <ModalBody>
          <Row className={"g-gs"}>
            <Form onSubmit={handleSubmit(onFormSubmit)} className="">
              {/* main complain  */}
              <Col md="" sm="6" xxl="12" className="mt-2">
                <div className="form-group">
                  <Label htmlFor="complain" className="feedback-label">
                    {"Complain"}
                  </Label>
                  <textarea
                    className="form-control address-textarea"
                    id="complain"
                    {...register("complain", {
                      required: "Complain is required",

                      minLength: {
                        value: 10,
                        message: "Complain must be at least 10 characters",
                      },
                      pattern: {
                        value: /^[a-zA-Z0-9\s,.'-]{10,100}$/,
                        message: "Please enter a valid complain format",
                      },
                    })}
                    rows={5}
                    cols="73"
                    readOnly
                  />
                  {errors?.complain && <p className="text-danger invalid mt-1">{errors?.complain?.message}</p>}
                </div>
              </Col>
              {/* Response  */}
              <Col md="" sm="6" xxl="12" className="mt-2">
                <div className="form-group">
                  <Label htmlFor="response" className="feedback-label">
                    {"Response"} <Required />
                  </Label>
                  <textarea
                    className="form-control address-textarea"
                    id="response"
                    {...register("response", {
                      required: "Response is required",

                      minLength: {
                        value: 10,
                        message: "Response must be at least 10 characters",
                      },
                      pattern: {
                        value: /^[a-zA-Z0-9\s,.'-]{10,100}$/,
                        message: "Please enter a valid response format",
                      },
                    })}
                    rows={5}
                    cols="73"
                  />
                  {errors?.response && <p className="text-danger invalid mt-1">{errors?.response?.message}</p>}
                </div>
              </Col>
            </Form>
          </Row>
        </ModalBody>
        <ModalFooter>
          <>
            <Button color="primary" className="feedback-btn" size="md" onClick={handleSubmit(onFormSubmit)}>
              {"Submit"}
            </Button>
          </>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Grievance;
